import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import {getUser, getUserQuizzingDetails} from '../../api';
import {ThinkscapeTable} from '../common';
import {Check, EmailOutlined, PersonOutline, SupervisorAccountOutlined} from '@material-ui/icons';
import {Grid, Typography} from '@material-ui/core';
import {calculateScore} from '../Quiz/UserReports/utils';
import {LoadingContext} from '../../contexts/LoadingContext';

export default function User(props) {
    const {match: {params: {userId}}} = props;
    const {setLoading} = useContext(LoadingContext);

    const [user, setUser] = React.useState(props.location.state);

    React.useEffect(() => {
        async function fetchUser() {
            await getUser(userId).then(response => setUser(response));
        }
        if (!user || user._id.$oid !== userId) {
            setLoading(true);
            fetchUser();
            setLoading(false);
        }
    }, []);

    return <div className="content-box">
        <div className="navigation-history-container">
            <Link to="/users">Users</Link> {user && `> ${user.userName}`}
        </div>
        {user && <>
            <h1 className="section-header">
                <div className="section-title">User Details</div>
            </h1>
            <Grid container spacing={2}>
                <Grid item xs={12}/>
                <Grid container item xs={4} spacing={0}>
                    <Grid item xs={1}>
                        <PersonOutline/>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Username </Typography>
                    </Grid>
                </Grid>
                <Grid item xs={8}>
                    <Typography>{unescape(user.userName)}</Typography>
                </Grid>
                <Grid container item xs={4} spacing={0}>
                    <Grid item xs={1}>
                        <EmailOutlined/>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Email </Typography>
                    </Grid>
                </Grid>
                <Grid item xs={8}>
                    <Typography>{unescape(user.email)}</Typography>
                </Grid>
                <Grid container item xs={4} spacing={0}>
                    <Grid item xs={1}>
                        <SupervisorAccountOutlined/>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>ID </Typography>
                    </Grid>
                </Grid>
                <Grid item xs={8}>
                    <Typography>{user.platformUserId}</Typography>
                </Grid>
                <Grid item xs={12}/>
            </Grid>
            <ThinkscapeTable
                itemName="users"
                hiddenFields={['actions']}
                getFieldsMapping={(details) => (
                    {
                        name: details.name,
                        complete: details.complete,
                        score: details.score,
                        percent: details,
                        result: details,
                        createdAt: details.createdAt.$date
                    })
                }
                fetchRecords={(args) => getUserQuizzingDetails(user._id.$oid, {
                    ...args,
                })}
                setLoading={setLoading}
                fieldsSettings={
                    {
                        name: {
                            sortable: true,
                            fieldText: 'Quiz Name',
                            formatData: unescape
                        },
                        complete: {
                            sortable: true,
                            fieldText: 'Complete',
                            formatData: cell => cell ? <Check/> : null
                        },
                        score: {
                            sortable: false,
                            fieldText: 'Points',
                            formatData: (cell, row) => !cell ? row.record.complete ? 0 : '-' : cell + '/' + row.record.questions.length
                        },
                        percent: {
                            sortable: true,
                            fieldText: 'Score (%)',
                            formatData: cell => cell.complete ?
                                (cell.percent * 100).toFixed(0)
                                : 'Incomplete'
                        },
                        result: {
                            sortable: false,
                            fieldText: 'Result',
                            formatData: (cell) => cell.options && cell.options.passFailThreshold ? cell.complete ?
                                calculateScore(cell) > cell.options.passFailThreshold ? 'Pass' : 'Fail' :
                                'Incomplete' : '-' //oldest quizzes lack options
                        },
                        createdAt: {
                            sortable: true,
                            fieldText: 'Date Attempted',
                            formatData: cell => {
                                let recentDate = new Date (cell);
                                let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
                                return recentDate.toLocaleString(undefined, options);
                            }
                        },
                    }
                }
            />
        </>
        }
        {!user && 'Loading...'}
    </div>;
}